import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Box } from '@mui/material';
import GoogleSignIn from '../components/GoogleSignIn';

const LoginPage = () => {
  const navigate = useNavigate();

  const handleLoginSuccess = (user) => {
    console.log('User logged in:', user);
    // Redirect to courses after successful login
    navigate('/courses');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center', // Center horizontally
        alignItems: 'center', // Center vertically
        minHeight: '100vh', // Ensure the box takes full viewport height
      }}
    >
      <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
        <Typography variant="h4" sx={{ mb: 4, fontWeight: 'bold' }}>
          Welcome Back!
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center', // Center the button horizontally
            alignItems: 'center', // Ensure button content is vertically centered
            mb: 4,
          }}
        >
          <GoogleSignIn onSuccess={handleLoginSuccess} />
        </Box>
      </Container>
    </Box>
  );
};

export default LoginPage;
